module.exports = __webpack_public_path__ + "img/Flag_of_Aruba.2c56d78b.svg";